import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import "./UpgradeDialog.scss";

const UpgradeConfirmationDialog = (props: any) => {
  const { open, onClose, onConfirm, type } = props;

  return (
    <Fragment>
      <div>
        <Dialog className="pw-confirmation-dialog" open={open}>
          <div className="pw-confirmation-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text">
                {type === "subscribe" ? "Subscribe" : "Upgrade"}
              </div>
              <div className="cursor-pointer">
                <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={onClose}
                />
              </div>
            </div>

            <div className="w-full mt-2 pw-color-neutral-900 text-md">
              {type === "subscribe" ? (
                <div>Are you sure you want to subscribe to selected plan?</div>
              ) : type === "plan" ? (
                <div>Are you sure you want to upgrade the subscription?</div>
              ) : (
                <div>Are you sure you want to buy addons?</div>
              )}
            </div>
          </div>
          <div className="flex flex-row justify-end pw-confirmation-dialog-footer w-full gap-6 py-3 mt-4">
            <div
              className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
              onClick={onClose}
            >
              Cancel
            </div>
            <button
              className={`pw-bunit-button-primary pw-bunit-button-next text-white font-bold cursor-pointer bg-primary px-4`}
              onClick={onConfirm}
            >
              {type === "subscribe" ? "Proceed" : "Proceed to pay"}
            </button>
          </div>
        </Dialog>
      </div>
    </Fragment>
  );
};

export default UpgradeConfirmationDialog;
